<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <info-table
          roleLinkField="employeePartnerRoles"
          updatePermissions="PROFILE.UPDATE"
          loginTitle="Login Partnera (e-mail)"
          :partner="partner"
          :profile="profile"
          :login="login"
          @showEditModal="showEditModal"
        />
      </v-flex>
    </v-layout>

    <modal :show="showModal" :id="editId" :edit="!!editId" :partner="partner" @close="hideModal" @update="update" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import { modalMixin } from '@/mixins/modal';
import store from '@/store/store';
import infoTable from '../profile/InfoTable';
import Modal from './modals/Profile.modal';

/**
 * @vuese
 * Profil
 * @group partners
 */
export default {
  components: { infoTable, Modal },
  mixins: [
    modalMixin('profiles', {
      getError: 'Wystąpił błąd podczas pobierania danych partnera.',
      updated: 'Zaktualizowano dane partnera.',
      updateError: 'Nie udało się zaktualizować danych partnera.'
    })
  ],
  props: {
    // id edytowanego profilu jeśli istnieje
    editProfileId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapState({
      profile: state => state.profiles.data.profile,
      login: state => state.profiles.data.login,
      id: state => state.profiles.data.profile.id,
      partner: state => state.partners.data
    }),
    editId() {
      if (this.editProfileId) {
        return this.editProfileId.toString();
      } else {
        return this.id.toString();
      }
    }
  }
};
</script>
